/* eslint-disable */
import React from 'react';
import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import pMinDelay from 'p-min-delay';
import { CircularProgress } from '@material-ui/core';
import PrivateRoute from './PrivateRoute';
import { loadTime } from '../../appConstants';
import PropTypes from 'prop-types';

const Home = loadable(() => pMinDelay(import('components/Home'), loadTime), {
	fallback: <CircularProgress />
});

const Login = loadable(() => pMinDelay(import('components/Login'), loadTime), {
	fallback: <CircularProgress />
});

const Inbox = loadable(() => pMinDelay(import('components/Inbox'), loadTime), {
	fallback: <CircularProgress />
});

const Candidates = loadable(() => pMinDelay(import('components/Candidates'), loadTime), {
	fallback: <CircularProgress />
});

const CandidateProfile = loadable(
	() => pMinDelay(import('components/CandidateProfile'), loadTime),
	{ fallback: <CircularProgress /> }
);

export const routes = {
	HOME: '/',
	LOGIN: '/login',
	INBOX_USER: '/inbox/user',
	INBOX_TEAM: '/inbox/team',
	CANDIDATES: '/candidates',
	CANDIDATE: '/candidate/:candidateId',
	THREAD: '/thread/:threadId'
};

const AppRoutes = () => {
	const { authenticated } = useSelector((state) => state.user);

	return (
		<div className="main">
			<Route exact path={routes.HOME} component={authenticated ? Home : Login} />
			<Route exact path={routes.LOGIN} component={Login} />
			<PrivateRoute
				exact
				path={routes.INBOX_TEAM}
				component={Inbox}
				authenticated={authenticated}
			/>
			<PrivateRoute
				exact
				path={routes.INBOX_USER}
				component={Inbox}
				authenticated={authenticated}
			/>
			<PrivateRoute
				exact
				path={routes.CANDIDATES}
				component={Candidates}
				authenticated={authenticated}
			/>
			<PrivateRoute
				exact
				path={routes.CANDIDATE}
				component={CandidateProfile}
				authenticated={authenticated}
			/>
			<PrivateRoute
				exact
				path={routes.THREAD}
				component={CandidateProfile}
				authenticated={authenticated}
			/>
		</div>
	);
};

AppRoutes.propTypes = {
	authenticated: PropTypes.bool,
	cloudEnvs: PropTypes.array,
	authenticateUser: PropTypes.func
};

export default AppRoutes;
